import { createContext, RefObject } from "react";

export interface MainLayoutContextValue {
  mainBoxRef: RefObject<HTMLDivElement> | null;
}

export const MainLayoutContext = createContext<MainLayoutContextValue>({ mainBoxRef: null });
